import { createAction, props, union } from "@ngrx/store";

export const showSpinner = createAction(
  "[Policy Spinner] Show",
  props<{ spinnerId: string; actionType: string }>()
);
export const hideSpinner = createAction(
  "[Policy Spinner] Hide",
  props<{ spinnerId: string; actionType: string }>()
);

const all = union({
  showSpinner,
  hideSpinner,
});

export type PolicySpinnerActionsUnion = typeof all;
